import React from "react";
import {CartContext} from "../cart/CartHandler";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import {ShoppingBagRounded} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import {LayoutContext} from "../layout/LayoutHandler";


const AddToCartContainer: React.FC = () => {
    const cartContext = React.useContext(CartContext);
    const layoutContext = React.useContext(LayoutContext);

    const direction = layoutContext.containerBp === "xs"
        ? "column"
        : "row";

    return (
        <Container sx={{
            position: "relative",
            zIndex: 100,
            boxShadow: "0px 0px 20px rgba(0,0,0,0.25)",
            padding: "0.75rem 1rem !important",
            maxWidth: "100% !important"
        }}>
            <Stack
                direction={direction}
                alignItems="center"
                justifyContent="space-between"
                spacing={1}
            >
                <Stack direction="row" spacing={2} alignItems="center">
                    <ShoppingBagRounded sx={{ color: '#314c3d', fontSize: '3rem' }} />
                    <Typography variant="body1" sx={{ color: '#314c3d', whiteSpace: 'nowrap', fontWeight: 600 }}>
                        Konfiguráció összege
                    </Typography>
                    <Typography variant="body1" sx={{
                        color: '#314c3d',
                        textDecoration: 'bold',
                        fontWeight: 700,
                        fontSize: '1.5rem',
                        whiteSpace: 'nowrap'
                    }}>
                        {cartContext.getCurrentConfigPrice() ?? 0} Ft
                    </Typography>
                </Stack>

                <Button
                    variant="outlined"
                    startIcon={cartContext.editedItem ? <CheckCircleIcon /> : <AddShoppingCartIcon />}
                    // A még fókuszban lévő (pl. név) input függőben lévő értékét commitoltatjuk:
                    // a mousedown az onClick ELŐTT fut, a blur kiváltja a TextFieldInput onBlur-ját,
                    // így a beírt név bekerül a paraméterekbe, mielőtt az addCurrentItem kiolvassa.
                    onMouseDown={() => (document.activeElement as HTMLElement | null)?.blur?.()}
                    onClick={() => cartContext.addCurrentItem()}
                    sx={{
                        flex: 1,
                        whiteSpace: 'nowrap',
                        borderColor: '#314c3d',
                        color: '#314c3d',
                        fontWeight: 600,
                        fontSize: '1.2rem',
                        maxWidth: '10rem',
                        textTransform: 'capitalize',
                        '&:hover': {
                            backgroundColor: 'rgba(49, 76, 61, 0.08)',
                            borderColor: '#314c3d',
                        },
                    }}
                >
                    {cartContext.editedItem ? "Mentés" : "Kosárba" }
                </Button>
            </Stack>
        </Container>
    );
}

export default AddToCartContainer;